export const homeChildren = [
  /*/*/
  {
    path: '/',
    name: '/',
    component: resolve => require(['@/components/pages/login/Login'], resolve),
    meta: {
      requiresAuth: false,
    }
  },
  /*studentInfo*/
  {
    path: '/studentInfo',
    name: 'studentInfo',
    component: resolve => require(['@/components/pages/studentInfo/studentInfo'], resolve),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/registration',
    name: 'registration',
    component: resolve => require(['@/components/pages/registration/registration'], resolve),
    meta: {
      requiresAuth: true
    }
  },
  /*test-success*/
  {
    path: '/testsuccess',
    name: 'testsuccess',
    component: resolve => require(['@/components/pages/testSuccess/testSuccess'], resolve),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/beginExe',
    name: 'beginExe',
    component: resolve => require(['@/components/pages/beginExe/beginExe'], resolve),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/author',
    name: 'author',
    component: resolve => require(['@/components/pages/author/author'], resolve),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/report',
    name: 'report',
    component: resolve => require(['@/components/pages/report/report'], resolve),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/analysis',
    name: 'analysis',
    component: resolve => require(['@/components/pages/analysis/analysis'], resolve),
    meta: {
      requiresAuth: true
    }
  },
  /*analysis*/
]



// WEBPACK FOOTER //
// ./src/router/homeChildren.js